module.exports = __webpack_public_path__ + "66da48aa9b9ac9379940387f2a1bb1ea.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/rising.png
// module id = 3042
// module chunks = 0